import { useAppRouter } from '@/common/route/useAppRouter';
import { StringUtils } from '@/common/utils/stringUtils';
import { useBaseListView } from '@/common/view/useBaseListView';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_LEAGUE } from '@/modules/league/router';
import { leagueService } from '@/services/league';
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';

export function useLeagueRewardList() {
    const router = useAppRouter();
    const route = useRoute();

    const itemId = StringUtils.toNumber(route.params.itemId);
    const tier = StringUtils.toNumber(route.params.tier);
    const canAddNew = ref(false);

    const loadLeagueItemTier = useCrudActions().executeAction({
        canExecute: () => itemId != null && tier != null,
        request: () => leagueService.tier.get(itemId, tier),
        onSuccess: ({ data }) => void (canAddNew.value = data.season === 2),
        onError: () => router.push({ name: ROUTE_NAME_LEAGUE.INDEX })
    });

    onMounted(loadLeagueItemTier);

    const { list, total, fetchList } = useBaseListView({
        request: leagueService.reward.list,
        paramsBuilder: () => ({ itemId, tier })
    });

    const actions = {
        remove: useCrudActions().confirmAndRemove({
            request: position => leagueService.reward.remove(itemId, tier, position),
            onSuccess: () => fetchList()
        })
    };

    const routes = {
        add: {
            name: ROUTE_NAME_LEAGUE.TIER.REWARD.ADD,
            params: { itemId, tier }
        },
        edit: (position: number) => ({
            name: ROUTE_NAME_LEAGUE.TIER.REWARD.EDIT,
            params: { itemId, tier, position }
        })
    };

    return { list, total, fetchList, canAddNew, actions, routes };
}
